import Flex from "components/grid/Flex";
import { Button, Dialog, MenuItem, TextField } from "@material-ui/core";
import { useFetchAnamnesisHistoryByPatientIdQuery } from "./AnamnesisApi";
import { useParams } from "react-router-dom";
import GeneralHistory from "./component/history/GeneralHistory";
import { useFetchPatientByIdQuery } from "../PatientApi";
import ChipHistory from "./component/history/ChipHistory";
import HematologyHistory from "./component/history/HematologyHistory";
import React, { useState } from "react";
import AnamnesisForm from "./component/AnamnesisForm";
import ArthroseHistory from "./component/history/ArthroseHistory";
import AllergiesHistory from "./component/history/AllergiesHistory";
import CardiovascularRiskFactorsHistory from "./component/history/CardiovascularRiskFactorsHistory";
import ClinicalSymptomsHistory from "./component/history/ClinicalSymptomsHistory";
import QualityOfLifeHistory from "./component/history/QualityOfLifeHistory";
import CancerHistory from "./component/history/CancerHistory";
import CardiovascularDiseaseHistory from "./component/history/CardiovascularDiseaseHistory";
import ComorbiditiesHistory from "./component/history/ComorbiditiesHistory";
import OtherDiseasesHistory from "./component/history/OtherDiseasesHistory";
import { getHistoryAt, noOnly, possibleVersions, versionNow, yesOnly } from "./HistoryUtils";
import { useTranslation } from "react-i18next";
import HivHistory from "./component/history/HivHistory";

const AnamnesisHistory = ({ route }) => {
    const { t } = useTranslation();
    const { patientId } = useParams();
    const { data: patientData } = useFetchPatientByIdQuery(patientId);
    const {
        data: anamnesisHistory,
        isSuccess: anamnesisHistoryLoadedSuccessfully,
        isLoading: anamnesisHistoryIsLoading,
    } = useFetchAnamnesisHistoryByPatientIdQuery({ patientId }, { skip: !patientId });
    const [isOpen, setOpen] = useState(false);
    const [visibleVersion, setVisibleVersion] = useState(versionNow());
    const [type, setType] = useState('yesOnly');
    const visibleVersions = [...possibleVersions(anamnesisHistory)];
    let filteredHistory = getHistoryAt(anamnesisHistory, visibleVersion);
    if(type === 'yesOnly') {
        filteredHistory = yesOnly(filteredHistory);
    } else if (type === 'noOnly') {
        filteredHistory = noOnly(filteredHistory);
    }
    return (
        <Flex item container column>
            <Flex item container grow={0} justifyContent={"space-between"} alignItems={"center"}>
                <Flex item container style={{ marginTop: 10 }} gap={10}>
                    <TextField
                        label={t("global.versions")}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        select
                        SelectProps={{
                            value: visibleVersion,
                            displayEmpty: true,
                            onChange: (event) => setVisibleVersion(event.target.value),
                        }}
                    >
                        {visibleVersions.map((version) => (
                            <MenuItem value={version}>{version}</MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label={"Filter"}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        select
                        SelectProps={{
                            value: type,
                            displayEmpty: true,
                            onChange: (event) => setType(event.target.value),
                        }}
                    >
                        <MenuItem value={"all"}>{t("global.all")}</MenuItem>
                        <MenuItem value={"yesOnly"}>{t("global.yesOnly")}</MenuItem>
                        <MenuItem value={"noOnly"}>{t("global.noOnly")}</MenuItem>
                    </TextField>
                </Flex>

                <Button variant={"outlined"} onClick={() => setOpen(true)}>
                    {t("anamnesis.edit-current")}
                </Button>
            </Flex>
            <GeneralHistory {...{ anamnesisHistory: filteredHistory, patientData }} />
            <ChipHistory {...{ anamnesisHistory: filteredHistory }} />
            <HematologyHistory {...{ anamnesisHistory: filteredHistory }} />
            <ArthroseHistory {...{ anamnesisHistory: filteredHistory }} />
            <HivHistory {...{ anamnesisHistory: filteredHistory }} />
            <AllergiesHistory {...{ anamnesisHistory: filteredHistory }} />
            <CardiovascularRiskFactorsHistory {...{ anamnesisHistory: filteredHistory }} />
            <ClinicalSymptomsHistory {...{ anamnesisHistory: filteredHistory }} />
            <QualityOfLifeHistory {...{ anamnesisHistory: filteredHistory }} />
            <CancerHistory {...{ anamnesisHistory: filteredHistory }} />
            <CardiovascularDiseaseHistory {...{ anamnesisHistory: filteredHistory }} />
            <ComorbiditiesHistory {...{ anamnesisHistory: filteredHistory }} />
            <OtherDiseasesHistory {...{ anamnesisHistory: filteredHistory }} />
            <Dialog open={isOpen} onClose={() => setOpen(false)} maxWidth={"xl"} fullWidth={true}>
                <AnamnesisForm {...{ closeDialog: () => setOpen(false) }} />
            </Dialog>
        </Flex>
    );
};

export default AnamnesisHistory;
